import React from 'react';

import PagePanel from 'src/components/PagePanel';
import { Container } from 'src/components/Container';
import PageHeader from 'src/components/PageHeader';
import { useTheme } from 'src/useTheme';

const Unauthorized = () => {
  const theme = useTheme();

  return (
    <PagePanel>
      <PageHeader title="Access denied" hideSearch />
      <Container marginTop="1rem" color={theme.midGrey}>
        Your account does not have permission to view this page. Contact an administrator if you believe this is a
        mistake.
      </Container>
    </PagePanel>
  );
};

export default Unauthorized;
